import { useEffect, useState } from "react";

// Single source of truth for responsive breakpoints. Matches the CSS
// breakpoints in src/App.css and src/components/Sidebar/Sidebar.css exactly
// (992px tablet, 768px mobile) so JS-driven page layouts never fall out of
// sync with the shared Sidebar/Navbar shell.
//
// Previously every page reimplemented its own window.innerWidth threshold
// from scratch - six different values existed across the app (640, 768,
// 900, 920, 992, 1200), none aligned with the shell or each other. Since
// browser zoom changes the effective viewport width the same way a resize
// does, these independent thresholds could flip at different zoom levels on
// the same page, causing the sidebar/nav chrome and page content to disagree
// about which layout mode is active.
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 992,
};

const getSnapshot = () => {
  const width = typeof window !== "undefined" ? window.innerWidth : BREAKPOINTS.tablet;
  return {
    width,
    isMobile: width < BREAKPOINTS.mobile,
    isTablet: width < BREAKPOINTS.tablet,
  };
};

export default function useResponsive() {
  const [state, setState] = useState(getSnapshot);

  useEffect(() => {
    const handleResize = () => setState(getSnapshot());
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return state;
}
